var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-skeleton-table',{attrs:{"rows":_vm.rows,"columns":_vm.columns,"table-props":_vm.table_props}})
}
var staticRenderFns = []

export { render, staticRenderFns }